export class AIInterviewStatistics {
  id?: string;
  opportunities?: InterviewObject[];
  quotes: InterviewQuote[];
  themes?: InterviewObject[];
  summary: string;
  statistics?: AIInterviewStatisticsDetails;
}

export class AIInterviewStatisticsDetails {
  averageTime: number;
  completedInterviews: number;
  completionRate: number;
  startedInterviews: number;
}

export class InterviewObject {
  title: string;
  body: string;
}

export class InterviewQuote {
  conversationId: string;
  quote: string;
  score: number;
}
